function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.2498 49.0001C40.2498 48.0336 41.0333 47.2501 41.9998 47.2501H48.9998C49.9663 47.2501 50.7498 48.0336 50.7498 49.0001C50.7498 49.9666 49.9663 50.7501 48.9998 50.7501H41.9998C41.0333 50.7501 40.2498 49.9666 40.2498 49.0001Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.24976 49.0001C5.24976 48.0336 6.03326 47.2501 6.99976 47.2501H13.9998C14.9663 47.2501 15.7498 48.0336 15.7498 49.0001C15.7498 49.9666 14.9663 50.7501 13.9998 50.7501H6.99976C6.03326 50.7501 5.24976 49.9666 5.24976 49.0001Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.25 28C12.25 27.0335 13.0335 26.25 14 26.25H42C42.9665 26.25 43.75 27.0335 43.75 28V49C43.75 49.9665 42.9665 50.75 42 50.75C41.0335 50.75 40.25 49.9665 40.25 49V29.75H15.75V49C15.75 49.9665 14.9665 50.75 14 50.75C13.0335 50.75 12.25 49.9665 12.25 49V28Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5833 18.6667C21.5833 17.7002 22.3668 16.9167 23.3333 16.9167H32.6666C33.6331 16.9167 34.4166 17.7002 34.4166 18.6667C34.4166 19.6332 33.6331 20.4167 32.6666 20.4167H23.3333C22.3668 20.4167 21.5833 19.6332 21.5833 18.6667Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.1162 3.98438C31.1159 3.98427 31.1164 3.9845 31.1162 3.98438L47.4472 13.0574C47.4469 13.0573 47.4475 13.0576 47.4472 13.0574C49.4856 14.1878 50.7498 16.338 50.7498 18.6667V49C50.7498 49.9665 49.9663 50.75 48.9998 50.75C48.0333 50.75 47.2498 49.9665 47.2498 49V18.6667C47.2498 17.6077 46.6747 16.631 45.7503 16.1186L29.4155 7.04345C28.5352 6.55372 27.4628 6.55325 26.5825 7.04298L10.2483 16.1178C9.32565 16.63 8.74976 17.6074 8.74976 18.6667V49C8.74976 49.9665 7.96625 50.75 6.99976 50.75C6.03326 50.75 5.24976 49.9665 5.24976 49V18.6667C5.24976 16.3381 6.51278 14.1887 8.54853 13.0582M8.54853 13.0582L24.881 3.98438C26.8189 2.90674 29.1783 2.90674 31.1162 3.98438C31.1159 3.98427 31.1164 3.9845 31.1162 3.98438",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.75 43.75V47.25H33.25V43.75H29.75ZM26.25 43.554C26.25 41.7271 27.7305 40.25 29.5563 40.25H33.446C35.2729 40.25 36.75 41.7305 36.75 43.5563V47.446C36.75 49.2729 35.2695 50.75 33.4437 50.75H29.554C27.7271 50.75 26.25 49.2695 26.25 47.4437V43.554Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.75 43.75V47.25H26.25V43.75H22.75ZM19.25 43.554C19.25 41.7271 20.7305 40.25 22.5563 40.25H26.446C28.2729 40.25 29.75 41.7305 29.75 43.5563V47.446C29.75 49.2729 28.2695 50.75 26.4437 50.75H22.5563C20.7288 50.75 19.25 49.2712 19.25 47.4437V43.554Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.2478 36.7477V40.25H29.7501V36.7477H26.2478ZM22.7478 36.554C22.7478 34.7306 24.2249 33.2477 26.0541 33.2477H29.9438C31.7673 33.2477 33.2501 34.7248 33.2501 36.554V40.4437C33.2501 42.2712 31.7713 43.75 29.9438 43.75H26.0541C24.2307 43.75 22.7478 42.2729 22.7478 40.4437V36.554Z",
  fill: "black"
});

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.96ccc1bc.svg";
export { ForwardRef as ReactComponent };